import { render, staticRenderFns } from "./RegisterExpenses.vue?vue&type=template&id=bab0f8cc&"
import script from "./RegisterExpenses.vue?vue&type=script&lang=js&"
export * from "./RegisterExpenses.vue?vue&type=script&lang=js&"
import style0 from "./RegisterExpenses.vue?vue&type=style&index=0&id=bab0f8cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports